module.exports = __webpack_public_path__ + "img/registration.6f90de3e.png";